export enum EstateDetailsMainTabValue {
  SUMMARY = 'summary',
  NOTES = 'notes',
  TASKS = 'tasks',
  DOCUMENTS = 'documents',
  ACTIVITIES = 'activities',
  STEPS = 'steps',
  INBOX = 'inbox',
  TAX_MODULE = 'taxModule',
  SNAPSHOT = 'snapshot',
  COUPLES_SPACE = 'couplesSpace',
  ANNUAL_REVIEW = 'annualReview'
}
